import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=0df8495f&scoped=true&"
import script from "./Publication.vue?vue&type=script&lang=js&"
export * from "./Publication.vue?vue&type=script&lang=js&"
import style0 from "./Publication.vue?vue&type=style&index=0&id=0df8495f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8495f",
  null
  
)

export default component.exports